<script>
  import Button from '@components/Button.svelte';
  import ReportContentAjax from '@ajax/report_content';
  import { getContext } from 'svelte';
  import { getCurrentUserStore } from '@stores/current_user';

  let currentUser = getCurrentUserStore('default');

  export let reportedContentKey;
  export let reportedContentId;
  export let text;
  export let noBorderRadius;

  const reportedContent = getContext('reportedContent');

  const handleUnreport = async function () {
    try {
      await ReportContentAjax.delete(reportedContentId);

      // Update the reportedContent store
      reportedContent.update((content) => {
        const updatedContent = { ...content };
        delete updatedContent[reportedContentKey];
        return updatedContent;
      });

      currentUser.update((user) => ({
        ...user,
        reported_content_count: Math.max((user.reported_content_count || 1) - 1, 0),
      }));
    } catch (error) {
      console.error('Error unblocking content:', error);
      // Optionally, you can add error handling here (e.g., show a notification)
    }
  };
</script>

<style style="text/scss" lang="scss">
  @import '../../vendor/design-system.scss';

  .flagged-by-user-overlay {
    text-align: center;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: rgba(255, 255, 255, 1);
    padding: 20px;
    border-radius: 20px;
    z-index: 3;
    display: flex; /* Added */
    justify-content: center; /* Added */
    align-items: center; /* Added */

    .inner {
      padding: 0 25px;
    }

    .text-section {
      margin-top: 14px;
      margin-bottom: 24px;
    }

    .subheader {
      font-size: 14px;
      color: $neutral-gray;
    }

    &.no-radius {
      border-radius: 0px;
    }
  }
</style>

<div class="flagged-by-user-overlay" class:no-radius={noBorderRadius}>
  <div class="inner">
    <img src="/images/report/hidden-eye.svg" alt="hide-icon" />
    <div class="text-section">
      <h4>Thanks for reporting!</h4>
      <p class="subheader">Your feedback is important to us. We’ll show you fewer lists like this in the future.</p>
    </div>
    <Button colorScheme="black" text={text} on:click={handleUnreport} />
  </div>
</div>
